"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKEND_URL_MAPPING = void 0;
// TODO: update with real backend URL
exports.BACKEND_URL_MAPPING = {
    'alpha': {
        'us-east-1': 'https://localhost:8443'
    },
    'beta': {
        'us-east-1': 'https://localhost:8443'
    },
    'gamma': {
        'us-east-1': 'https://localhost:8443'
    },
    'prod': {
        'us-east-1': 'https://localhost:8443'
    }
};
//# sourceMappingURL=url_mapping.js.map